module.exports = __webpack_public_path__ + "img/selini.9bb89bbf.jpg";